import { CommonModule } from '@angular/common';
import { Component, input, output } from '@angular/core';

@Component({
  selector: 'app-toast',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './toast.html',
  styleUrls: ['./toast.scss']
})
export class ToastComponent {

  // Variants
  variant = input<'info' | 'success' | 'warning' | 'error'>('info');
  position = input<'top-left' | 'top-right' | 'bottom-left' | 'bottom-right' | 'top-center'>('top-right');
  // Content
  title = input('Message Title');
  description = input('');
  actionLabel = input<string>();  // Visibility
  showPrefixIcon = input(true);
  showAction = input(true);
  showClose = input(true);
  visible = input(true);

  // Outputs
  actionClick = output<void>();
  closeClick = output<void>();

  onAction(): void {
    this.actionClick.emit();
  }

  onClose(): void {
    this.closeClick.emit();
  }
}